import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";
import { selectCurrentUserAccountId } from "app/containers/Global/slice";
import {
  selectGetTeamAndDepartmentLeadsStatus,
  selectTeamAndDepartmentLeadIdsForLoggedInUser,
} from "app/containers/AdminConsole/slice";
import {
  getManagerAndDirectReports,
  selectGettingSingleUserManagerAndDirectReportsStatus,
  selectManagerAndDirectReportsByUserAccountId,
} from "app/containers/AdvancedCsvUpload/slice";

// An individual contributor (IC) leads no teams and manages no users.
// Returns undefined while either source is still loading so callers can render a
// placeholder instead of flashing the wrong UI. If a request fails we return false,
// since showing manager UI to an IC is safer than hiding it from a manager.
export const useIsIndividualContributor = (): boolean | undefined => {
  const dispatch = useAppDispatch();
  const currentUserAccountId = useAppSelector(selectCurrentUserAccountId);
  const teamAndDepartmentLeaderOf = useAppSelector(
    selectTeamAndDepartmentLeadIdsForLoggedInUser
  );
  const managerAndDirectReportsByUserAccountId = useAppSelector(
    selectManagerAndDirectReportsByUserAccountId
  );
  const teamLeadsStatus = useAppSelector(selectGetTeamAndDepartmentLeadsStatus);
  const directReportsStatus = useAppSelector(
    selectGettingSingleUserManagerAndDirectReportsStatus
  );

  useEffect(() => {
    if (!currentUserAccountId) return;
    dispatch(
      getManagerAndDirectReports({ userAccountId: currentUserAccountId })
    );
  }, [dispatch, currentUserAccountId]);

  const directReports = currentUserAccountId
    ? managerAndDirectReportsByUserAccountId[currentUserAccountId]
    : undefined;

  if (teamLeadsStatus === "failed" || directReportsStatus === "failed") {
    return false;
  }
  if (!teamAndDepartmentLeaderOf || !directReports) return undefined;

  const leadsTeams = !!teamAndDepartmentLeaderOf.teams?.length;
  const managesUsers = !!directReports.directReportRelationships?.length;
  return !leadsTeams && !managesUsers;
};
